import React, { useState } from "react";
import {
    Form,
    Button,
    Offcanvas,
    Card,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./login.scss";
import { HiOutlineEnvelope } from "react-icons/hi2";
import { Label } from "../Common/Label/Label";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import Password from "../Common/Password/Password";
import logo from "../../assets/images/logo.svg";
import banner from "../../assets/images/loginimage1.png";

const AdminSetPassword = () => {
    const {
        setValue,
        register,
        handleSubmit,
        formState: { errors },
        watch,
        setError,
        reset,
        clearErrors
    } = useForm();
    const watchVariable = watch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [loader, setLoader] = useState(false)
    const state = useLocation();
    const token = useParams();

    const handleResetPassword = () => {

        if (watchVariable.newPassword !== watchVariable.cpassword) {
            setError("cpassword", {
                type: "custom",
                message: "New password and Confirm password didn’t match.",
            });
            return;
        }

        setLoader(true)
        WebService.addLoader('resetPassword')
        if (token.token) {
            WebService.postAPI({
                action: `user/set-password?token=${token.token}&password=${watchVariable.newPassword}`,
                body: null,
                isShowError: true,
            }).then((res: any) => {
                WebService.removeLoader('resetPassword')
                toast.success(res.message)
                window.open(`https://dashboard.justbreathe.in/login`)
            }).catch((error: any) => {
                WebService.removeLoader('resetPassword')
                return false;
            })
        } else {
            let body = {
                email: state.state,
                password: watchVariable.newPassword
            }
            return WebService.putAPI({
                action: `user/reset/password`,
                body: body,
                isShowError: true
            }).then((res: any) => {
                setLoader(false)
                WebService.removeLoader('resetPassword')
                toast.success(res.message)
                navigate('/login')
            }).catch((error: any) => {
                setLoader(false)
                WebService.removeLoader('resetPassword')
                return error
            })
        }
    }

    const handleOnChange = (value: any, type: any) => {
        if (type === "newPassword") {
            setValue("newPassword", value);
            clearErrors("newPassword");
            if (watchVariable.newPassword === "") {
                setError("newPassword", {
                    type: "custom",
                    message: "Please enter new password",
                });
            }
        } else if (type === "cpassword") {
            setValue("cpassword", value);
            clearErrors("cpassword");
            if (watchVariable.cpassword === "") {
                setError("cpassword", {
                    type: "custom",
                    message: "Please enter confirm password",
                });
            }
        }
    };

    return (
        <>
            <div className="login-page">
                <div className="row g-0">
                    <div className="col-lg-7">
                        <img src={banner} className="login-img" alt="" />
                    </div>
                    <div className="col-lg-5 d-flex align-items-center justify-content-center">
                        <div className="mb-3 w-100">
                            <Form
                                name="Verify"
                                id="Verify"
                                onSubmit={handleSubmit(handleResetPassword)}
                            >
                                    <div className="px-3 pt-3">
                                        <div className="  mb-4">
                                            <img src={logo} width="150" alt="Logo" />
                                        </div>
                                        <div className=" ">
                                            <h4 className="text-brand mb-4">{t("RESET_PASSWORD")}</h4>
                                            {/* <p className="text-secondary">
                                            {t("OTPlabel_heading")}
                                        </p> */}
                                            <div className="input-group mb-2 mt-1">
                                                <Password
                                                    requiredMsg={{
                                                        ...register("newPassword", {
                                                            required: "Please enter new password",
                                                            pattern: {
                                                                value:
                                                                    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!*-])(?=.*[a-zA-Z@#$%^&+=!*-]).{6,}$/,
                                                                message:
                                                                    // "Passwords should contain a combination of six character types[Min 1 uppercase letter + Min 1 lowercase letter + Min 1 number + Min 1 Special character allowed (@ # $ % ^ & + = !)]",
                                                                    "Password must be at least 6 characters, and contains at least 1 uppercase/lowercase, numbers & special characters "

                                                            },
                                                        }),
                                                    }}
                                                    inputFieldClassName="form-control border-end-0 border-start-0 ps-0"
                                                    id=""
                                                    name=""
                                                    label={t('NEW_PASSWORD')}
                                                    placeholder={t('NEW_PASSWORD')}
                                                    method={(event: any) => {
                                                        handleOnChange(event.target.value, "newPassword");
                                                        clearErrors("newPassword")
                                                    }}
                                                    onError={
                                                        errors.newPassword ? (
                                                            <div className="mb-2">
                                                                <Label
                                                                    title={
                                                                        errors.newPassword.message
                                                                        && errors.newPassword.message.toString()
                                                                    }
                                                                    modeError={true}
                                                                    showStar={true}
                                                                    type="password"
                                                                />
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )
                                                    }
                                                />{" "}
                                            </div>
                                            <div className="input-group mb-2 mt-0">
                                                <Password
                                                    requiredMsg={{
                                                        ...register("cpassword", {
                                                            required: "Please enter confirm password",
                                                        }),
                                                    }}
                                                    inputFieldClassName="form-control border-end-0 border-start-0 ps-0"
                                                    id="123"
                                                    name=""
                                                    label={t('CONFIRM_PASSWORD')}
                                                    placeholder={t('CONFIRM_PASSWORD')}
                                                    method={(event: any) => {
                                                        handleOnChange(event.target.value, "cpassword");
                                                        clearErrors("cpassword")
                                                    }}
                                                    onError={
                                                        errors.cpassword ? (
                                                            <Label
                                                                title={
                                                                    errors.cpassword.message
                                                                    && errors.cpassword.message.toString()
                                                                }
                                                                modeError={true}
                                                                showStar={true}
                                                                type="password"
                                                            />
                                                        ) : (
                                                            ""
                                                        )
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="px-3">
                                            <Button className="btn-brand-1 w-100" type="submit" id="resetPassword">
                                                {t("SAVE_PASSWORD")}
                                            </Button>
                                        </div>

                                        <div className="text-center mt-3 font-14 font-medium">
                                            {t("Back")} {t("to")}
                                            <Link to="/login" className="text-brand font-14">
                                                {t("Login")}
                                            </Link>
                                        </div>
                                    </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdminSetPassword;